import usePublicEventService from "@app-contexts/public/features/event-detail/data/services/usePublicEventsService";
import { IPublicBasket } from "@app-contexts/public/features/basket/interfaces/IPublicBasket";
import { VenueBasedTicketItemGroupSerializer } from "@shared/modules/basket/types/common/ticket-item-group/serializer-types";
import { TicketItemGroupType } from "@shared/modules/item-groups/types/ticket-item-group-type";
import { useMemo } from "react";
import { IVenueBasket } from "../interfaces/IVenueBasket";

export function usePackageItemGroup(
  itemGroup: VenueBasedTicketItemGroupSerializer,
  basketService: IPublicBasket | IVenueBasket
) {
  const { itemGroups } = basketService;

  const packageRequiresSelection = useMemo(
    () =>
      Boolean(
        itemGroups &&
          itemGroups.find(
            (item: TicketItemGroupType) =>
              item.requires_seat_or_location_selection
          )
      ),
    [itemGroups]
  );

  const subItems = useMemo(() => {
    const subgroups: Array<VenueBasedTicketItemGroupSerializer> = [];
    if (!itemGroup.parent) {
      itemGroups.forEach((group) => {
        if (group.parent === itemGroup.id) subgroups.push(group);
      });
    }
    return subgroups;
  }, [itemGroups, itemGroup]);

  const subItemsQuantity = useMemo(() => {
    if (subItems.length === 0) return 0;
    return subItems.reduce(
      (acc, group) => acc + Number(group?.quantity ?? 1),
      0
    );
  }, [subItems]);

  // fetch event data to get the full ticket type data
  const { useRetrieveWithMembershipTicketTypesOverride } =
    usePublicEventService();
  const { data: eventPackageData } =
    useRetrieveWithMembershipTicketTypesOverride(Number(itemGroup.event), {
      options: {
        enabled: Boolean(itemGroup.event && subItems.length > 0),
      },
    });

  const customPackageParent = useMemo(
    () =>
      eventPackageData?.ticket_types?.find(
        (tt) => tt.id === itemGroup.type && tt.is_custom_package
      ),
    [eventPackageData]
  );

  return {
    subItems,
    subItemsQuantity,
    customPackageParent,
    packageRequiresSelection,
    hasCustomPackage: Boolean(customPackageParent),
  };
}
